import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageHelperService } from '../../shared/services/storage.helper';

export const unAuthorizeGuard: CanActivateFn = async (route, state) => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  const token = inject(StorageHelperService).checkExistToken;

  if (!token) {
    return true;
  }

  router.navigate(['/case-studies']);
  return false;
};
